import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	perUserPerMonth: {
		id: 'recommend-standard-over-premium.price-contrast.per-user-per-month',
		defaultMessage: 'per user/month',
		description: 'Phrase indicating that the displayed price is on a per user per month basis.',
	},
});
